/**
 * User: Keith
 * Author: Faris
 * Date: 6/24/15
 * Time: 10:30 AM
 */

define('app/views/meetings',['require','./page','text!../../../views/meetings.html'],function(require) {

  var Page = require('./page');
  var template = require('text!../../../views/meetings.html');

  return Page.extend({
	 template: _.template(template),
	 
	 events: {
	     'click .meeting-title' : 'onClickTitle'
	 },
	 
	 beforeTransitionIn : function() {	     
	     // Check to find out which content box to open based on path passed in
	     var path = window.location.pathname;
	     // Check if this is the first child
	     if(this.model.attributes.SORTORDER==1) {
	         $("#meetings").addClass('first-child');
	     }
	     
	     // Make sure this path exits
	     if($('.meeting-item[data-path="'+path+'"]').length) {
	        this.currentMeetingID = $('.meeting-item[data-path="'+path+'"]').data('meetingid');
	        this.showContent(path);
	     } else if($(".meeting-item").length) {
	         // Open the first content
	         // Scroll content to top
	         $(".meeting-item:first-of-type").closest(".meeting-item").find(".mCustomScrollbar").mCustomScrollbar("scrollTo", "top");
	         
	         // Set ID
	         this.currentMeetingID = $(".meeting-item:first-of-type").closest(".meeting-item").data('meetingid');
             
	         // Open first 
	         $(".meeting-item:first-of-type").closest(".meeting-item").find('.description').slideDown(400, function() {	             
	             $(this).closest(".meeting-item").find(".mCSB_draggerContainer").fadeIn();
	         });
	     }
	 },
	 
	 onClickTitle : function(e) {
	     // Get the meeting ID
	     //var currentMeetingID = $(e.target).closest(".meeting-item").data("meetingid");
	     
	     // Update path
	     var path = $(e.target).closest(".meeting-item").data("path");
	     
	     // If mobile, go to page
	     if($(window).width()<=768) {
	         window.s.router.navigate(path, {trigger: true});
	     } else {
    	     window.s.router.navigate(path, { trigger: false, replace: true });
    	     
    	     this.showContent(path);
	     }
	 },
	 
	 // Show the current content area
	 showContent: function(path) {	     
	     // Close currently opened content
	     $(".meeting-item[data-meetingid='"+this.currentMeetingID+"']").closest(".meeting-item").find(".description").slideUp(400, function(){
	         // Open the selected path
	         // Set meeting id
	         this.currentMeetingID = $('.meeting-item[data-path="'+path+'"]').data('meetingid');
	         
	         // Expand it
	         $('.meeting-item[data-path="'+path+'"]').addClass("active");
	         $('.meeting-item[data-path="'+path+'"]').find(".mCustomScrollbar").mCustomScrollbar("scrollTo", "top");
	         $('.meeting-item[data-path="'+path+'"]').find('.description').slideDown(400, function() {                 
	             $(this).closest(".meeting-item").find(".mCSB_draggerContainer").fadeIn();
	         });
	         
	         // Fade in the correct background
	         $('#meetingsBg .mainBackground:visible').each(function(i, ele) {
	             if(!$(ele).data('path')==path) {
	                 $(ele).fadeOut();
	             }
	         });
	         $('#meetingsBg .mainBackground[data-backgroundid="'+this.currentMeetingID+'"]').fadeIn();
	         
	         // Fade in the correct photo
	         $('.smallImage .photo:visible').each(function(i, ele) {
	             if(!$(ele).data('path')==path) {
                     $(ele).fadeOut();
                 }
	         });
	         $('.smallImage .photo[data-photoid="'+this.currentMeetingID+'"]').fadeIn();
	         
	     }.bind(this));	     
	 }
  });
});
